<template>
    <p class="font-size-sm mb-0 color-primary clickable" @click="openMortgage">
      {{cellProps}}
    </p>
</template>

<script>
export default {
  name: "MortgageNumberCell.vue",
  props: {
    cellProps: {
      type: String
    },
    row: {
      type: Object,
      required: true
    },
  },
  methods:{
    openMortgage(){
      this.navigator.openPath(this.route('mortgage.show', [this.row.customer.data.id, this.row.id]));
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
